import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import config from '../../config';
import { FormOutlined, PlusOutlined, GroupOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Button, Typography, Tooltip, notification } from 'antd';
import { intialPaginationState, showingPageTotalRange, filter, unexpectedError } from '../../common_functions/index';

const Users = props => {
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
    await getUsers(pagination);
  })();
  }, []);

  const getUsers = async (pagination, filters = {}, sorter = '') => {
    try {
      setLoading(true);
      const sort =
        !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + (sorter.field === 'role' ? 'role.name' : sorter.field) : '-id';
      const response = await props.getUsersData('users', {
        fields: ['id,first_name,last_name,email,status,role.id,role.name'],
        sort: sort,
        filters: filters,
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });
      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setUsers(response.data);
    } catch (error) {
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };
  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'First Name',
      dataIndex: 'first_name',
      key: 'first_name',
      sorter: true,
      ...filter('first_name'),
      render: (text, record) => <span style={{ textTransform: 'capitalize' }}>{text}</span>,
    },
    {
      title: 'Last Name',
      dataIndex: 'last_name',
      key: 'last_name',
      sorter: true,
      ...filter('last_name'),
      render: (text, record) => <span style={{ textTransform: 'capitalize' }}>{text}</span>,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      sorter: true,
      ...filter('email'),
    },
    {
      title: 'User Role',
      dataIndex: 'role',
      key: 'role',
      sorter: true,
      ...filter('role'),
      render: role => {
        return config.userRoleTypes[role.id] && <span style={{ textTransform: 'capitalize' }}>{role.name}</span>;
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      ...filter('status'),
      render: status => {
        return <span style={{ textTransform: 'capitalize' }}>{status}</span>;
      },
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Tooltip placement="top" title="Edit User">
              <Link to={'/users/edit/' + record.id}>
                <button className="edit-btn">
                  <FormOutlined />
                </button>
              </Link>
            </Tooltip>
            {record.role.name.toLowerCase() !== 'administrator' && (
              <Link to={'/users/manage-permissions/' + record.id}>
                <Tooltip placement="top" title="Manage Permissions">
                  <button className="edit-btn">
                    <GroupOutlined />
                  </button>
                </Tooltip>
              </Link>
            )}

            {/* <Popconfirm
              placement="left"
              title="Are you sure you want to delete this User?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => userDeleteConfirm(record.id)}
              overlayStyle={{ width: '500px' }}
              disabled={props?.user?.id === record.id}
            >
              <button className="delete-btn" disabled={props?.user?.id === record.id} style={{ cursor: 'pointer' }}>
                <DeleteOutlined style={{ color: 'red' }} />
              </button>
            </Popconfirm> */}
          </div>
        </span>
      ),
      //width: "10%",
    },
  ];

  let handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);
    let filtersitems = {};
    for (var key in filters) {
      if (filters.hasOwnProperty(key)) {
        if (filters[key]) {
          filtersitems[key] = key === 'role' ? { name: { _icontains: filters[key][0] } } : { _icontains: filters[key][0] };
        }
      }
    }
    await getUsers(pagination, filtersitems, sorter);
  };
  // Delete user
  let userDeleteConfirm = async record => {
    if (props?.user?.id === record) {
      return false;
    }
    try {
      await props.deleteUser('users', record);
      setUsers(users.filter(item => item.id !== record));
      notification.success({
        message: 'User deleted successfully!',
      });
    } catch (error) {
      notification.error({
        message: 'Error occured while deleting the user!',
      });
    }
  };

  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Users" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                Users List
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              <Link to="/users/new">
                <Button icon={<PlusOutlined />} className="align-right" type="primary" size="small">
                  Create User
                </Button>
              </Link>
            </Col>
          </Row>
          <hr />
          <div className="users-list">
            {
              <Table
                scroll={{ x: 'max-content' }}
                columns={columns}
                bordered
                //rowKey = {record => record.id}
                dataSource={users}
                pagination={{ ...pagination, ...showingPageTotalRange }}
                loading={loading}
                onChange={handleTableChange}
              />
            }
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default Users;
